import React, {useEffect, useReducer} from 'react'
import {LOGOUT_SUCCESS} from "../../constants/constants";
import {URL_FRONT} from "../../utils/globalConfig";

const initialState = {
    user: (window.localStorage.getItem("user") !== null && window.localStorage.getItem("user") !== "undefined") ? JSON.parse(window.localStorage.getItem("user")) : null,
    token: (window.localStorage.getItem("token") !== null && window.localStorage.getItem("token") !== "undefined")  ? JSON.parse(window.localStorage.getItem("token")) : null,
    profil: (window.localStorage.getItem("profil") !== null && window.localStorage.getItem("profil") !== "undefined")  ? JSON.parse(window.localStorage.getItem("profil")) : null,
};

const deconnexionReducer = (state, action) => {
    switch (action.type) {
        case LOGOUT_SUCCESS:
            return {
                ...state,
                user: null,
                token: null,
                profil: null,
            };
        default:
            return state;
    }
}

const Deconnexion = () => {
    const [state, dispatch] = useReducer(deconnexionReducer, initialState);

    const handleLogout = () => {
        if (state.user !== null) {
            dispatch({
                type: LOGOUT_SUCCESS
            });
            window.localStorage.removeItem("token");
            window.localStorage.removeItem("user");
            window.localStorage.removeItem("profil");
            document.location.href = URL_FRONT + "/";
        }
    }

    useEffect(() => {
        handleLogout();
    });

    return (
        <div/>
    )
}

export default Deconnexion;
